<template>
  <v-hover>
    <v-card
      slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`"
      height="100%"
      color="#FAFAFA"
    >
      <router-link
        :to="{ name: 'workRequest', params: { idapplication: workRequest.IdApplication }}"
      >
        <v-card-title
          :class="[$vuetify.breakpoint.xsOnly ? 'd-block' : 'd-flex']" :style="'cursor: pointer; pointer-events: visible;background-color:'+(workRequest.StageCode == 'A' || workRequest.StageCode == 'O' ? 'grey' : 'green')+'; color:white;padding-top:5px;padding-bottom:5px;'"
        >
          <!-- <v-icon dark left :color="workRequest.Color">{{workRequest.Icon}}</v-icon> -->      
          <v-flex v-if="workRequest.Priority">
            <i :title="$t('equipment.workRequests.priority')" class="mr-2 ml-1 fab fa-hotjar" :style="{fontSize: priorityStyle(workRequest.Priority) + 'px'}" :class="[priorityClass(workRequest.Priority)]"></i>
            <span :title="$t('equipment.workRequests.priority')" :style="{fontSize: priorityStyle(workRequest.Priority) - 5 + 'px'}">{{workRequest.Priority}}</span>
          </v-flex>
          <v-flex>
            <v-icon class="mr-1" color="blue">directions</v-icon>
            <span>{{workRequest.DirectionName + ' '}}</span>
          </v-flex>
          <v-flex>
            <v-icon class="mr-1" color="orange">category</v-icon>
            <span>{{workRequest.CategoryName}}</span>
          </v-flex>
          <v-flex text-xs-right>
            <span class="subheading">№ {{workRequest.IdApplication}}</span>
          </v-flex>
        </v-card-title>
      </router-link>

      <v-card-text>
        <v-layout column>
          <v-layout
            :align-center="$vuetify.breakpoint.smAndUp"
            class="subheading font-weight-light"
            :wrap="$vuetify.breakpoint.smAndUp"
            :column="!$vuetify.breakpoint.smAndUp"
          >
            <v-flex v-if="workRequest.DeclarerName">
              <v-icon class="mr-1" color="green">person</v-icon>
              <span>{{ workRequest.DeclarerName }}</span>
            </v-flex>

            <v-flex v-if="workRequest.ResponsibleName">
              <v-icon class="mr-1" color="orange">directions_run</v-icon>
              <span>{{ workRequest.ResponsibleName }}</span>
            </v-flex>
            <v-spacer></v-spacer>
            <v-layout :justify-end="$vuetify.breakpoint.smAndUp" align-center>
              <v-icon class="mr-1" color="blue">access_time</v-icon>
              <span>{{ workRequest.TimeAfterCreation }}</span>
              <v-icon v-if="workRequest.AttachmentCount" :title="$t('equipment.workRequests.attachmentTitle')">attach_file</v-icon>
              <!-- <v-btn
                icon
                v-if="workRequest.AttachmentCount"
                :title="$t('equipment.workRequests.pictures')"
                @click.native.stop="$router.push({ name: 'WorkRequestAttachments', params: { workRequest: Object } })"
              >
                <v-icon>attach_file</v-icon>
              </v-btn>-->
            </v-layout>
          </v-layout>
          <p
            class="font-weight-medium subheading"
            style="word-wrap:break-word"
            v-if="contentLength(workRequest.Content)"
          >{{workRequest.Content}}</p>
          <p v-else class="font-weight-medium subheading" style="word-wrap:break-word">
            {{ openText(workRequest.Content)}}
            <v-btn tile icon small class="ma-0" @click="fullText = !fullText">
              <v-icon>{{!fullText ? 'fa-angle-down' : 'fa-angle-up'}}</v-icon>
            </v-btn>
          </p>
          <v-divider />
          <router-link
            v-if="workRequest.EquipmentCode"
            :to="{ name: 'equipment', params: { equipmentId: workRequest.EquipmentCode }}"
          >
            <span
              class="subheading font-weight-light text--lighten-blue"
            >{{workRequest.EquipmentName}} ({{workRequest.EquipmentCode}})</span>
          </router-link>
        </v-layout>
      </v-card-text>
      <v-card-actions style="background-color:#f7faff;">
        <v-layout wrap>
          <v-layout align-center>
            <v-icon class="mr-1" :color="workRequest.CanPerform ? 'green': 'red'">control_camera</v-icon>
            <span>{{ workRequest.StageName }}</span>
          </v-layout>
          <v-layout align-center justify-end>
            <!-- <WorkRequestStageButtons :workRequest="workRequest" /> -->
            <!-- <WorkRequestAdditionalForm :workRequest="workRequest" /> -->

            <v-menu
              v-if="workRequest.CanAssign && workRequest.CanPerform && (workRequest.StageCode == 'R' || workRequest.StageCode == 'E')"
              v-model="menu"
              :close-on-content-click="false"
              lazy
              nudge-left="120"
              left
              offset-y
              full-width
            >
              <template slot="activator">
                <v-flex pr-2>
                  <v-btn color="orange" dark icon :loading="loading">
                    <v-icon>{{workRequest.StageCode == 'R' ? 'person_add' : 'people'}}</v-icon>
                  </v-btn>
                </v-flex>
              </template>
              <v-card>
                <v-list>
                  <v-list-tile
                    v-for="(item, index) in responsibleList"
                    :key="index"
                    @click="menu=false; if(item.Code)
                    modifyWorkRequests({workRequestId : workRequest.IdApplication, action: workRequest.StageCode == 'R' ?'setperformer':'changeperformer', additionalParams: item.Code})"
                  >
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.Name }}</v-list-tile-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
              </v-card>
            </v-menu>

            <!-- <v-dialog v-model="commentDialog" lazy max-width="700">
              <v-btn slot="activator" color="blue" dark :loading="loading" icon>
                <v-icon>comment</v-icon>
              </v-btn>
              <v-card>
                <v-progress-linear v-if="loading" :indeterminate="loading" ma-0></v-progress-linear>
                <v-list>
                  <v-list-tile v-for="(item, index) in comments" :key="index">
                    <v-list-tile-content>
                      <v-list-tile-title>{{ item.USER }}</v-list-tile-title>
                      <v-list-tile-sub-title>{{ item.TEXT }}</v-list-tile-sub-title>
                    </v-list-tile-content>
                  </v-list-tile>
                </v-list>
                <v-card-text>
                  <v-text-field v-model="comment" :label="$t('enterComment')"></v-text-field>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="green darken-1"
                    flat
                    @click="commentDialog = false; modifyWorkRequests({workRequestId : workRequest.IdApplication, action: 'comment', additionalParams: comment}); comment = ''"
                  >{{ $t('submit') }}</v-btn>
                  <v-btn
                    color="green darken-1"
                    flat
                    @click="commentDialog = false"
                  >{{ $t('cancel') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>-->
          </v-layout>
        </v-layout>
      </v-card-actions>
    </v-card>
  </v-hover>
</template>

<script>
import { mapActions } from 'vuex'
import 'swiper/dist/css/swiper.css'
import WorkRequestStageButtons from '../components/WorkRequestStageButtons'
//import WorkRequestAdditionalForm from '../components/WorkRequestAdditionalForm'

export default {
  components: {
    WorkRequestStageButtons,
    //WorkRequestAdditionalForm
  },
  props: {
    workRequest: Object,
    validator: function(value) {
      return ['IdApplication', 'StageCode'].indexOf(value) !== -1
    }
  },
  methods: {
    ...mapActions([
      'modifyWorkRequests',
      'updatePerformers',
      'updateWorkRequestAttachments',
      'updateWorkRequests'
    ]),
    priorityClass(value){
      return value <= 3 ? "red--text" : value <= 7 ? "orange--text" : " yellow--text"
    },
    priorityStyle(value){
      return 28 - value;
    },
    contentLength(str) {
      return str.length < 300
    },
    openText(content) {
      return this.fullText ? content : content.substring(0, 300)
    }
  },
  data() {
    return {
      dialogFinish: false,
      closeDialog: false,
      toDeclarerDialog: false,
      cancelDialog: false,
      attachmentDialog: false,
      hideImageControls: false,
      menu: false,
      fab: false,
      fullText: null,
      // swiperOption: {
      //   slidesPerView: 1,
      //   spaceBetween: 30,
      //   loop: false,
      //   pagination: {
      //     el: ".swiper-pagination",
      //     clickable: true
      //   },
      //   navigation: {
      //     nextEl: ".swiper-button-next",
      //     prevEl: ".swiper-button-prev"
      //   }
      // }
    };
  },
  computed: {
    responsibleList() {
      return this.$store.state.workRequests.responsibleList
    },
    attachments() {
      return this.$store.state.workRequests.attachments
    },
    loading() {
      return this.$store.state.base.loading
    }
  },
  watch: {
    menu() {
      if (this.menu) {
        this.updatePerformers({
          workRequestId: this.workRequest.IdApplication
        })
      }
    },
    attachmentDialog() {
      if (this.attachmentDialog) {
        this.updateWorkRequestAttachments({
          workRequestId: this.workRequest.IdApplication
        })
      }
    },
    isAuthenticated() {
      this.updateWorkRequests()
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none !important;
  color: blue !important;
}
</style>